import React from 'react'
import Helmet from 'react-helmet'
import { ThemeProvider } from 'styled-components'
import theme from '../styles/theme'
import '../styles/global'
import favicon from './favicon.ico'

const TemplateWrapper = ({ children }) => (
  <ThemeProvider theme={theme}>
    <div>
      <Helmet>
        <title>BCCA Voices - Community Benefits Agreement</title>
        <link rel="icon" href={favicon} />
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta name="description"
          content="Voice your concerns" />
        <meta property="og:title" content="Community Benefits Agreement" />
        <meta property="og:description"
          content="Voice your concerns" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Community Benefits Agreement" />
        <meta property="og:url"
          content="http://voices.bccassn.com/" />
        <link
          href="https://fonts.googleapis.com/css?family=PT+Serif:400,700|Source+Sans+Pro:400,600"
          rel="stylesheet"
        />
      </Helmet>
      {children()}
    </div>
  </ThemeProvider>
)

export default TemplateWrapper



// WEBPACK FOOTER //
// ./src/layouts/index.js